<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { generateUUID } from '@common/utils/strings';

  export let row = {};

  const id = generateUUID();

  const create = () => {
    const activity = row.activity;
    const emailviewed = row.emailviewed;
    const total = Object.values(row.recips).filter((item) => !item.includes('bcc.hubspot.com'));
    const emails = total.slice();
    const viewed = [];

    let count = 0;

    if (emailviewed && emails.length) {
      for (let i = 0, k = activity.length; i < k; i++) {
        const record = activity[i];
        const recipient = record.recipient;

        if (
          (record.objecttype === 'adclick' ||
            record.objecttype === 'websitevisit' ||
            (record.objecttype === 'beaconview' && record.verb === 'viewed')) &&
          emails.includes(recipient)
        ) {
          count++;
          viewed.push(recipient);
          emails.splice(emails.indexOf(recipient), 1);
        }

        if (!emails.length) {
          break;
        }
      }
    }

    return {
      count,
      total: total.length,
      unseen: emails,
      seen: viewed
    };
  };

  $: emailviewed = row.emailviewed;
  $: badgeClassName = emailviewed ? (results.unseen.length ? 'badge-partiall-read' : 'badge-read') : 'badge-unread';
  $: badgeText = emailviewed ? $format('label.READ') : $format('label.UNREAD');
  $: results = create(row.activity);
</script>

<div id="tooltip-{id}" class={badgeClassName}>
  {badgeText}

  {#if results.seen.length && results.unseen.length}
    ({results.count}/{results.total})
  {/if}
</div>
<Tooltip target="tooltip-{id}" placement="top">
  {#if results.seen.length}
    {#if results.unseen.length}
      <div class="group">
        <div class="title">{$format('label.VIEWED_BY')}</div>
        <div class="items">{@html results.seen.join('<br>')}</div>
      </div>
    {:else}
      <div class="group">{$format('label.VIEWED_BY_EVERYONE')}</div>
    {/if}
  {/if}
  {#if results.unseen.length}
    <div class="group">
      <div class="title">{$format('label.NOT_SEEN_BY')}</div>
      <div class="items">{@html results.unseen.join('<br>')}</div>
    </div>
  {/if}
</Tooltip>

<style lang="scss">
  [class*='badge-'] {
    border-radius: calc(var(--border-radius-base) + 1px);
    display: inline-block;
    font-size: var(--font-size-small);
    padding: var(--padding-small) var(--padding-base);
    text-transform: uppercase;
    white-space: nowrap;
  }

  [class*='badge-read'] {
    background-color: var(--color-green-500);
  }

  [class*='badge-partiall-read'] {
    background-color: #1ea28e;
  }

  [class*='badge-unread'] {
    background-color: var(--color-gray-800);
  }

  .group {
    + .group {
      margin-top: var(--margin-base);
    }

    .title {
      font-weight: var(--font-weight-medium);
    }
  }
</style>
